import { UploadExcelThemeSizeConfig } from './types';

const medium: UploadExcelThemeSizeConfig = {
  uploadExcel: {},
};

export default medium;
